<template>
  <fieldset>
    <legend class="visuallyhidden">{{ contact.type }} Contact Details</legend>
    <div class="field">
      <div class="field-body">
        <div class="field">
          <label class="label input-wrapper" :class="{ active : contact.name.length }">
            <span class="input-label">{{ contact.type }} Name</span>
            <template v-if="isCompany">
              <input v-model="contact.name" v-validate="'required'" data-vv-as="name" required name="company_name" class="input" type="text" placeholder="Company Name">
              <span class="form-messages">{{ errors.first('company_name') }}</span>
            </template>
            <template v-else>
              <input v-model="contact.name" v-validate="'required'" data-vv-as="name" required name="customer_name" class="input" type="text" placeholder="Customer Name">
              <span class="form-messages">{{ errors.first('customer_name') }}</span>
            </template>
          </label>
        </div>
        <div class="field">
          <label class="label input-wrapper" :class="{ active : contact.email.length }">
            <span class="input-label">{{ contact.type }} Email</span>
              <input v-model="contact.email" v-validate="'email'" data-vv-as="email" class="input" :name="`${isCompany ? 'company_email' : 'customer_email'}`" type="email" :placeholder="contact.type + ' Email'">
              <span class="form-messages">{{ isCompany ? errors.first('company_email') : errors.first('customer_email') }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="field-body">
        <div class="field">
          <label class="label input-wrapper" :class="{ active : contact.address.length }">
            <span class="input-label">{{ contact.type }} Address</span>
            <input v-model="contact.address" class="input" :name="`${isCompany ? 'company_address' : 'customer_address'}`" type="text" :placeholder="contact.type + ' Address'"/>
          </label>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="field-body">
        <div class="field">
          <label class="label input-wrapper" :class="{ active : contact.city.length }">
            <span class="input-label">{{ contact.type }} City</span>
            <input v-model="contact.city" class="input" :name="`${isCompany ? 'company_city' : 'customer_city'}`" type="text" :placeholder="contact.type + ' City'"/>
          </label>
        </div>
        <div class="field">
          <label class="label input-wrapper" :class="{ active : contact.zip.length }">
            <span class="input-label">{{ contact.type }} Zip/postal code</span>
            <input v-model="contact.zip" class="input" :name="`${isCompany ? 'company_zip' : 'customer_zip'}`" type="text" :placeholder="contact.type + ' Postal Code'"/>
          </label>
        </div>
      </div>
    </div>
    <div class="field">
      <div class="field-body">
        <div class="field">
          <label class="label input-wrapper" :class="{ active : contact.country.length }">
            <span class="input-label">{{ contact.type }} Country</span>
            <div class="select-wrapper">
              <country-select
                v-model="contact.country"
                :country="contact.country"
                :name="`${isCompany ? 'company_country' : 'customer_country'}`"
                topCountry="US"
              />
            </div>
          </label>
        </div>
        <div class="field">
          <label class="label input-wrapper" :class="{ active : contact.region.length }">
            <span class="input-label">{{ contact.type }} State/Province</span>
            <div class="select-wrapper">
              <region-select
                v-model="contact.region"
                :name="`${isCompany ? 'company_region' : 'customer_region'}`"
                :country="contact.country"
                :region="contact.region"
                regionName="true"
              />
            </div>
          </label>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'InvoiceFormContactFields',
  props: {
    contact: {
      type: Object,
      required: true
    }
  },
  computed: {
    isCompany: function () {
      if (this.contact.type === 'Company') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
